import * as React from "react";
import PrivateRoute from "./PrivateRoute";
import RestrictedRoute from "./RestrictedRoute";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";

import {
  error as errorRoutes,
  auth as authRoutes,
  pref as prefRoutes,
  account as accountRoutes,
  reporting as reportingRoutes,
  switchboard as switchboardRoute,
  userManagement as userManagementRoutes,
  fileUpload as FileUploadRoute,
  home as homeRoute,
} from "./index";

import Page404 from "../pages/Error/404";
import SimpleLayout from "../layouts/Simple";
import DefaultLayout from "../layouts/Default";

const childRoutes = (Layout: any, routes: RouteTypes[]) =>
  routes.map((route, index: number) => {
    const {
      path,
      isPrivate,
      restrictedTo,
      children,
      component: Component,
      layout: PLayout,
    } = route;

    let RouteType: any = Route;
    if (isPrivate) {
      RouteType = PrivateRoute;
    }
    if (restrictedTo) {
      RouteType = RestrictedRoute;
    }
    if (PLayout) {
      Layout = PLayout;
    }

    return children ? (
      // Route item with children
      children.map((childRoute, index) => {
        const { path, isPrivate, restrictedTo, component: Component, layout: CLayout } = childRoute;

        let ChildRouteType = RouteType; // If child has more restrictive setting than parent
        if (isPrivate) {
          ChildRouteType = PrivateRoute;
        }
        if (restrictedTo) {
          ChildRouteType = RestrictedRoute;
        }
        if (CLayout) {
          Layout = CLayout;
        }

        return (
          <ChildRouteType
            exact
            key={index}
            path={path}
            restrictedTo={restrictedTo}
            render={(props: any) => (
              <Layout>
                <Component {...props} />
              </Layout>
            )}
          />
        );
      })
    ) : (
      // Route item without children
      <RouteType
        exact
        key={index}
        path={path}
        restrictedTo={restrictedTo}
        render={(props: any) => (
          <Layout>
            <Component {...props} />
          </Layout>
        )}
      />
    );
  });

const Routes = () => (
  <Router>
    <Switch>
      <Route exact path="/">
        <Redirect to="/auth/sign-in" />
      </Route>
      <Route exact path="/home">
        <Redirect to="/home/dashboard" />
      </Route>
      <Route exact path="/file">
        <Redirect to="/file/lse" />
      </Route>
      <Route exact path="/pref/search">
        <Redirect to="/preference/dashboard" />
      </Route>
      <Route exact path="/pref/add">
        <Redirect to="/preference/add" />
      </Route>
      <Route exact path="/pref/key">
        <Redirect to="/preference/keyword-simulator" />
      </Route>
      <Route exact path="/customer/edit">
        <Redirect to="/account/edit" />
      </Route>
      <Route exact path="/customer/communications">
        <Redirect to="/account/communications" />
      </Route>
      <Route exact path="/customer/audit">
        <Redirect to="/account/audit" />
      </Route>
      <Route exact path="/report/dashboard">
        <Redirect to="/reporting/dashboard" />
      </Route>
      <Route exact path="/report/change">
        <Redirect to="/reporting/change" />
      </Route>
      <Route exact path="/switchboard">
        <Redirect to="/switchboard/dashboard" />
      </Route>
      <Route exact path="/user-management">
        <Redirect to="/user-management/current-users" />
      </Route>

      {childRoutes(SimpleLayout, errorRoutes)}
      {childRoutes(DefaultLayout, homeRoute)}
      {childRoutes(DefaultLayout, FileUploadRoute)}
      {childRoutes(DefaultLayout, authRoutes)}
      {childRoutes(DefaultLayout, prefRoutes)}
      {childRoutes(DefaultLayout, accountRoutes)}
      {childRoutes(DefaultLayout, reportingRoutes)}
      {childRoutes(DefaultLayout, switchboardRoute)}
      {childRoutes(DefaultLayout, userManagementRoutes)}

      <Route
        render={() => (
          <DefaultLayout>
            <Page404 />
          </DefaultLayout>
        )}
      />
    </Switch>
  </Router>
);

export default Routes;
